import {
  UPLOAD_ASSET_FAILURE,
  UPLOAD_ASSET_PROGRESS,
  UPLOAD_ASSET_REQUEST,
  UPLOAD_ASSET_SUCCESS,
} from '../constants/actionTypes';

const upload = (state, action) => {
  switch (action.type) {
    case UPLOAD_ASSET_REQUEST:
      return {file: action.file, progress: 0, failed: false, error: null};
    case UPLOAD_ASSET_PROGRESS:
      if (action.file === state.file) {
        return {file: action.file, progress: action.progress, failed: false, error: null};
      } else return state;
    case UPLOAD_ASSET_SUCCESS:
      if (action.file === state.file) {
        return {file: action.file, progress: 100, failed: false, error: null};
      } else return state;
    case UPLOAD_ASSET_FAILURE:
      if (action.file === state.file) {
        return {file: action.file, progress: null, failed: true, error: action.error};
      } else return state;
    default:
      return state;
  }
};

const uploads = (state = [], action) => {
  switch (action.type) {
    case UPLOAD_ASSET_REQUEST:
      return [...state, upload(undefined, action)];
    case UPLOAD_ASSET_SUCCESS:
    case UPLOAD_ASSET_PROGRESS:
    case UPLOAD_ASSET_FAILURE:
      return state.map(up => upload(up, action));
    default:
      return state;
  }
};

export default uploads;



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./src/reducers/uploadsReducer.js